import * as angular from "angular";
import { ResetPasswordService, RESET_PASSWORD_SERVICE } from './reset-password.service';
import { configRoute } from "./reset-password.router";

export default angular
    .module("board.web.admin.resetPassword", [
        "board.web.admin.brdForm"
    ])
    .service(RESET_PASSWORD_SERVICE, ResetPasswordService)
    .config(configRoute)
    .name;


// WEBPACK FOOTER //
// ./app/reset-password/reset-password.module.ts